export default __webpack_public_path__ + "static/MS-026b2502e6440eb50390b8d0e273b045.pdf";